import { initializeApp } from "firebase/app";
import "firebase/auth";
import { getAuth } from "firebase/auth";
import { getMessaging } from "firebase/messaging";
import { getFirestore } from "firebase/firestore";

// const firebaseConfig = {
//   apiKey: "AIzaSyC_t9Jq9x2W_65mKFkK7XgUTz0RiCY_-TI",
//   authDomain: "curry-king-prod-454216.firebaseapp.com",
//   projectId: "curry-king-prod-454216",
//   storageBucket: "curry-king-prod-454216.firebasestorage.app",
//   messagingSenderId: "803543880665",
//   appId: "1:803543880665:web:41d62433e67ed344277fc8",
//   measurementId: "G-GJ89ED9X79"
// };
const apiKey = process.env.REACT_APP_API_KEY_PROD;
const authDomain = process.env.REACT_APP_authDomain_PROD;
const projectId = process.env.REACT_APP_projectId_PROD;
const storageBucket = process.env.REACT_APP_storageBucket_PROD;
const messagingSenderId = process.env.REACT_APP_messagingSenderId_PROD;
const appId = process.env.REACT_APP_appId_PROD;
const measurementId = process.env.REACT_APP_measurementId_PROD;
// const vapidKey = process.env.REACT_APP_vapidKey_PROD;


const firebaseConfig = {
    apiKey: apiKey,
    authDomain: authDomain,
    projectId: projectId,
    storageBucket: storageBucket,
    messagingSenderId: messagingSenderId,
    appId: appId,
    measurementId: measurementId
};


const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const messaging = getMessaging(app);
export const db = getFirestore(app);